import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StatisticsRoutingModule } from './statistics-routing.module';
import { StatisticsComponent } from './statistics.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import {  MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { GlobalComponent } from './components/global/global.component';
import { DeviceComponent } from './components/device/device.component';
import {MatTableModule} from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { SharedModule } from '../../shared/shared/shared.module';


@NgModule({
  declarations: [StatisticsComponent, GlobalComponent, DeviceComponent],
  imports: [
    CommonModule,
    StatisticsRoutingModule,
    NgxChartsModule,
    MatDividerModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatCardModule,
    SharedModule
  ],
  providers: [{ provide: LOCALE_ID, useValue: "fr-FR" }],
})
export class StatisticsModule { }
